<template>
  <div>
    <div>
      <div class="content">
        <div class="inner">
          <h1 class="title">
            <strong>Find</strong>
          </h1>

          <div class="actions">
            <input class="txtsearch" type="text" v-model="query">
          </div>

          <div v-show="!loaded && query">
            <div class="lds-dual-ring"></div>
          </div>
          <ul class="list scroller" v-show="loaded">
            <li :key="page.ItemID" v-for="page in filteredResults">
              <router-link :to="{ name: 'page-edit', params: { id: page.ItemID, type: page.SubItemType }}">
                <i class="fa fa-file-o"></i>
                {{page.name}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api"

export default {
  name: "Find",
  data: function() {
    return {
      loaded: false,
      query: "",
      results: [],
      schema: { exclude: [] }
    }
  },
  created() {
    var promises = []
    promises.push(
      api
        .getSpecificSchema("find")
        .then(response => {
          this.schema = JSON.parse(JSON.stringify(response)).items
        })
        .catch(() => {})
    )

    // this.schema = { exclude: ["settings", "gallery", "profiles"] }

    promises.push(
      api.getAllPages(this.schema).then(response => {
        this.results = response
      })
    )

    Promise.all(promises).finally(() => this.$nextTick().then((this.loaded = true)))
  },
  computed: {
    filteredResults: function() {
      if (!this.query) return []

      return this.results.filter(page => page.name.toLowerCase().indexOf(this.query.toLowerCase()) > -1 && !this.schema.exclude.includes(page.SubItemType))
    }
  }
}
</script>

<style scoped>
.txtsearch {
  width: 100%;
  max-width: 500px;
  padding: 1rem 2rem;
  border-radius: 5px;
  font-size: 2rem;
  border: 2px solid #e1e1e1;
}
</style>
